<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 41 30" style="enable-background:new 0 0 41 30;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#286588;}
	.st1{clip-path:url(#SVGID_00000116951184123974643270000007864651060567460485_);fill:#FFFFFF;}
	.st2{clip-path:url(#SVGID_00000069398487809833094170000014302197485527195049_);fill:#FFFFFF;}
</style>
<path id="Vector_11_00000146499727680557924700000014168706310838297261_" class="st0" d="M11.4,18.2l0-2.8l9.2-0.9
	c1.6-1.6,10.8-6.6,12.8-4.1l0,4.2c-3.6,2.7-9.7,0.3-12,1.1l-3.9,3.7c-2.2,0.8-5.4,2.1-6.1,1.7"/>
<g>
	<g>
		<defs>
			<rect id="SVGID_1_" x="0.4" width="41" height="30"/>
		</defs>

			<path id="Vector_13_00000174562322647467706880000013600526159184140688_" style="clip-path:url(#SVGID_00000168820502349495053160000008133166328739257992_);fill:#FFFFFF;" d="
			M28,13.9c0,0,0-0.1,0.1-0.2c0.1-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.3-0.2,0.5-0.1c0.2-0.1,0.4-0.2,0.6-0.2s0.4-0.2,0.6-0.2
			c0.4-0.1,0.7-0.2,1-0.3c0.2-0.1,0.5-0.1,0.7-0.1c0.3-0.1,0.6-0.1,0.9-0.1"/>
	</g>
</g>
<g>
	<g>
		<defs>
			<rect id="SVGID_00000024709179437035947750000013553886265267392150_" width="41" height="30"/>
		</defs>

			<path id="Vector_17_00000019659921398883568130000002200287157488597149_" style="clip-path:url(#SVGID_00000040544763465994568730000015630853726328163250_);fill:#FFFFFF;" d="
			M11.9,19.1c-0.2,0-0.3,0-0.3,0s0-0.1,0.1-0.1c0.1-0.1,0.4-0.2,0.8-0.4c0.2-0.1,0.4-0.2,0.7-0.3c0.3-0.1,0.6-0.2,0.9-0.3
			c0.3-0.1,0.6-0.2,0.9-0.3c0.5-0.2,1-0.3,1.5-0.4c0.3-0.1,0.7-0.2,1-0.2c0.4-0.1,0.8-0.2,1.2-0.3"/>
	</g>
</g>
</svg>
